import type { FC } from "react"

import { BetaTag } from "../components/BetaTag"
import { BioMeshMap } from "../components/BioMesh/BioMeshMap"
import { BioMeshUIStateProvider } from "../components/BioMesh/BioMeshUIStateContext"
import { MainContent } from "../components/MainContent"

export const BioMeshPage: FC = () => {
  return (
    <BioMeshUIStateProvider>
      <MainContent
        headerProps={{
          title: (
            <>
              BioMesh <BetaTag />
            </>
          ),
          documentTitle: "BioMesh",
        }}
        disableHorizontalGutters
      >
        <BioMeshMap />
      </MainContent>
    </BioMeshUIStateProvider>
  )
}
